import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowDownIcon, ArrowRightIcon, CheckIcon } from 'lucide-react';
import { BrowLine } from './BrowLine';
import { prepSteps } from '../../data/content';

/** Section 10 — the "I have a brow class tomorrow" moment. */
export function ClassPrepSection() {
  const reduce = useReducedMotion();
  return <section aria-labelledby="prep-heading" className="bg-brand-champagne px-5 py-16 lg:px-8 lg:py-24" data-id="element-54" data-mp="1xymxrbte78b0">
      <div className="mx-auto max-w-6xl text-center" data-id="element-55" data-mp="2loqynbf74tyb">
        <p className="font-display text-[1.3rem] italic text-brand-charcoal/60" data-id="element-56" data-mp="2pqvumgt4a2o4">Tomorrow’s class is coming…</p>
        <h2 id="prep-heading" className="mt-3 font-display text-[2.4rem] font-bold uppercase leading-[1.04] tracking-[-0.01em] text-brand-charcoal sm:text-[3.1rem] lg:text-[3.6rem]" data-id="element-57" data-mp="2brw22y2hh3mo">
          “I Have a Brow Class Tomorrow.”
        </h2>
        <p className="mt-4 font-display text-[1.6rem] font-semibold italic text-brand-gold sm:text-[1.9rem]" data-id="element-58" data-mp="15clphveazqn2">
          No Panic. No Blank Page.
        </p>

        <ol className="mx-auto mt-12 flex max-w-sm flex-col items-stretch lg:max-w-none lg:flex-row lg:items-stretch" role="list" data-id="element-59" data-mp="3hb27mbuf2jfb">
          {prepSteps.map((step, index) => <li key={step} className="flex flex-col items-center lg:flex-1 lg:flex-row" data-id="element-60" data-mp="3r8q2r2vxpsy0" data-mpi={index}>
              {index > 0 && <>
                  <ArrowDownIcon className="my-2 h-4 w-4 text-brand-gold lg:hidden" strokeWidth={1.75} aria-hidden="true" data-id="element-61" data-mp="42h11996t9is" />
                  <ArrowRightIcon className="mx-1.5 hidden h-4 w-4 flex-none text-brand-gold lg:block" strokeWidth={1.75} aria-hidden="true" data-id="element-62" data-mp="2hso1lw7qz" />
                </>}
              <motion.div initial={reduce ? false : {
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.24,
            ease: [0.23, 1, 0.32, 1],
            delay: index * 0.05
          }} className="flex w-full items-center gap-4 rounded-[16px] bg-white px-5 py-4 text-left shadow-[0_14px_30px_-24px_rgba(90,70,40,0.6)] lg:h-full lg:flex-col lg:justify-center lg:gap-3 lg:px-3 lg:py-6 lg:text-center" data-id="element-63" data-mp="8tp6xvbb6cr7">
                <span className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-brand-oatmeal font-display text-[1.15rem] font-bold text-brand-charcoal" data-id="element-64" data-mp="zrem42vk2j0r">
                  {index + 1}
                </span>
                <span className="font-body text-[14px] font-semibold leading-snug text-brand-charcoal" data-id="element-65" data-mp="19kvj1fqzoe8n">{step}</span>
              </motion.div>
            </li>)}
        </ol>

        <div className="mt-12 flex flex-col items-center" data-id="element-66" data-mp="1ika3nykh5ul8">
          <BrowLine className="h-7 w-32 text-brand-gold/50" data-id="element-67" data-mp="1nittwb63psje" />
          <p className="mt-4 flex items-center gap-4 font-display text-[3rem] font-bold uppercase leading-none tracking-[0.02em] text-brand-charcoal sm:text-[4.5rem]" data-id="element-68" data-mp="1ng7l687h56zl">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-cta sm:h-14 sm:w-14" data-id="element-69" data-mp="3pagkibm2zlfc">
              <CheckIcon className="h-6 w-6 text-white sm:h-7 sm:w-7" strokeWidth={2.5} aria-hidden="true" data-id="element-70" data-mp="3hsii0r2bhalm" />
            </span>
            Class <em className="italic text-brand-gold" data-id="element-71" data-mp="380cnpaoleh39">Ready.</em>
          </p>
          <p className="mx-auto mt-6 max-w-xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-72" data-mp="37y9p429djfmx">
            Brow Instructor Ready™ helps reduce class-preparation friction by giving you a professional
            structure to build from.
          </p>
        </div>
      </div>
    </section>;
}